var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconApiKey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.17021 13.2891C6.53901 13.6615 6.96454 13.8477 7.44681 13.8477C7.92908 13.8477 8.35461 13.6615 8.7234 13.2891C9.0922 12.9167 9.2766 12.487 9.2766 12C9.2766 11.513 9.0922 11.0833 8.7234 10.7109C8.35461 10.3385 7.92908 10.1523 7.44681 10.1523C6.96454 10.1523 6.53901 10.3385 6.17021 10.7109C5.82979 11.0833 5.65957 11.513 5.65957 12C5.65957 12.487 5.82979 12.9167 6.17021 13.2891ZM12.5957 10.1523H22V13.8477H20.1702V17.5H16.5532V13.8477H12.5957C12.2269 14.8503 11.5319 15.7096 10.5106 16.4258C9.51773 17.1419 8.49645 17.5 7.44681 17.5C5.94326 17.5 4.65248 16.9701 3.57447 15.9102C2.52482 14.8216 2 13.5182 2 12C2 10.4818 2.52482 9.19271 3.57447 8.13281C4.65248 7.04427 5.94326 6.5 7.44681 6.5C8.49645 6.5 9.51773 6.85807 10.5106 7.57422C11.5319 8.29036 12.2269 9.14974 12.5957 10.1523Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconApiKey);
export default __webpack_public_path__ + "static/media/icon-api-key.5745cbb8baa109e126ba782ef914d8f7.svg";
export { ForwardRef as ReactComponent };